import MatchingCheckout from './MatchingCheckout.page';

export default MatchingCheckout;
